import script from "./register.vue?vue&type=script&lang=ts&setup=true"
export * from "./register.vue?vue&type=script&lang=ts&setup=true"

import "./register.vue?vue&type=style&index=0&id=6119a986&scoped=true&lang=less"

import exportComponent from "E:\\Project\\health-force-aia-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6119a986"]])

export default __exports__